import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/menu'
  },
  {
    path: '/menu',
    component: () => import('@/views/Menu.vue')
  },
  {
    path: '/play',
    component: () => import('@/views/PlayerContact.vue')
  },
  {
    path: '/level',
    component: () => import('@/views/LevelStart.vue')
  },
  {
    path: '/failed',
    component: () => import('@/views/LevelFailed.vue')
  },
  {
    path: '/win',
    component: () => import('@/views/YouWin.vue')
  },
  {
    path: '/game',
    component: () => import('@/views/Game.vue')
  },
  {
    path: '/quiz',
    component: () => import('@/views/Quiz.vue')
  },
  {
    path: '/credits',
    component: () => import('@/views/Credits.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
